// import React, { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import toast from "react-hot-toast";
// import "./OtpVerification.css";
// import Swal from "sweetalert2";



import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./OtpVerification.css";
import { toast } from "react-toastify";


const OtpVerification = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const inputRefs = useRef([]);

  const { email } = location.state || {};

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (!/^[0-9]?$/.test(value)) return; // Allow only numbers

    let newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1].focus(); // Move to next input
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus(); // Move to previous input
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").slice(0, 6).replace(/\D/g, "");
    if (pasteData.length === 6) {
      setOtp([...pasteData]);
      inputRefs.current[5].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.includes("")) {
      setError("Please enter a 6-digit OTP");
      return;
    }

    setError("");
    setLoading(true);
    const otpCode = otp.join("");

    try {
      const response = await fetch("https://riymay.com/api/v1/user/email/verification", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, otp: otpCode }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "OTP verification failed");
      }


      toast.success("✅ Email verified successfully!", {
        position: "top-right",
        autoClose: 5000, // 5 seconds
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        onClose: () => navigate("/"),
      });
    } catch (err) {
      setError(err.message);

toast(`❌ Oops... ${err.message}`, {
  position: "top-right",
  autoClose: 5000, // 5 seconds
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "colored",
});

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="otp-verification-container">
      <div className="otp-verification-box">
        <span className="otp-verification-borderLine"></span>
        {loading && <div className="otp-verification-loader"><div className="loader"></div></div>}
        <form className="otp-verification-form" onSubmit={handleSubmit}>
          <h1 className="otp-verification-heading">OTP Verification</h1>
          <p className="otp-verification-para">Please Check your mail</p>
          <div className="otp-input-container" onPaste={handlePaste}>
            {otp.map((digit, index) => (
              <input
                key={index}
                type="number"
                maxLength="1"
                className="otp-input"
                value={digit}
                onChange={(e) => handleChange(index, e)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                ref={(el) => (inputRefs.current[index] = el)}
              />
            ))}

          </div>
          <br/> {error && <span className="otp-verification-error">{error}</span>}

          <button type="submit" className="otp-button" disabled={loading || otp.includes("")}>
            Verify OTP
          </button>
        </form>
      </div>
    </div>
  );
};

export default OtpVerification;










// const OtpVerification = () => {
//   const [otp, setOtp] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Extract email and ID from navigation state
//   const { email, id } = location.state || {};

//   const handleOtpSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     try {
//       const response = await fetch("https://riymay.com/api/v1/user/email/verification", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email, otp }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || "OTP verification failed");
        
//       }
//       // console.log(data)
//       // toast.success("Email verified successfully!");

//       Swal.fire({
//         icon:"success",
//         title: "Success!",
//         text: "Email verified successfully!", // Success message text
//         timer: 5000, // Automatically close after 5 seconds
//         timerProgressBar: true, // Show a progress bar for the timer
//         toast: true, // Enable toast mode
//         position: "top-end", // Position it at the top-end of the screen
//         showConfirmButton: false,
//       })
//       // console.log("email verified successfully!");
//       navigate("/");
//     } catch (err) {
//       setError(err.message);
//       Swal.fire({
//         icon: "error", // Error icon
//         title: "Oops...",
//         text: err.message, // Dynamic error message
//         timer: 20000, // Automatically close after 20 seconds
//         timerProgressBar: true, // Show a progress bar for the timer
//         showConfirmButton: false, // Hide the confirmation button for a toast-like behavior
//         toast: true, // Enable toast mode
//         position: "top-end", // Position it at the top-end of the screen
//       });
      
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
    
//     <div className="otp-verification-container">
//       <div className="otp-verification-box">
//       <span className="otp-verification-borderLine"></span>
//       {error && <p className="otp-verification-error">{error}</p>}

//       {loading && (
//         <div className="otp-verification-loader">
//           <div className="loader"></div> {/* Spinner for loading */}
//         </div>
//       )}

//       <form className="otp-verification-form" onSubmit={handleOtpSubmit}>
//       <h1 className="otp-verification-heading">OTP Verification</h1>
//       <p className="otp-verification-para">Please Check your mail</p>
//         <div className="otp-form-group">
//           <input
//             type="text"
//             name="otp"
//             placeholder="Enter OTP"
//             className="otp-input"
//             value={otp}
//             onChange={(e) => setOtp(e.target.value)}
//             required
//           />
           
//         </div>
//         <button type="submit" className="otp-button">
//           Verify OTP
//         </button>
//       </form>
//       </div>
//     </div>
//   );
// };







// export default OtpVerification;
